var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1071.843,694.9l-8.549-8.549a6.476,6.476,0,1,0-2.294,2.694l8.349,8.349a.29.29,0,0,0,.409,0l2.084-2.085A.289.289,0,0,0,1071.843,694.9Z","transform":"translate(-1050.416 -676.665)","fill":"none","stroke":"#fff","strokeMiterlimit":"10","strokeWidth":"1"}));
}

Search.defaultProps = {"width":"22.012","height":"21.318","viewBox":"0 0 22.012 21.318"};

module.exports = Search;

Search.default = Search;
